import AccountTreeIcon from "@mui/icons-material/AccountTreeOutlined";
import CasesIcon from "@mui/icons-material/CasesOutlined";
import ChecklistIcon from "@mui/icons-material/ChecklistRounded";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLongOutlined";
import UploadFileIcon from "@mui/icons-material/UploadFileOutlined";
import type { SvgIconComponent } from "@mui/icons-material";
import type { Color } from "@mui/material";
import { Avatar } from "@mui/material";
import { blue, deepPurple, grey, orange, teal } from "@mui/material/colors";
import type { WorkflowType } from "@entrilia/shared/api/workflowTypes";
import MoneyIcon from "@entrilia/shared/icons/MoneyIcon";
import { makeModeAwareAccentSurface } from "@entrilia/shared/utilities/colorHelper";
import type { WorkflowTemplateCategory } from "../../api/types/workflowTypes";

interface Props {
  workflowType: WorkflowType;
  category: WorkflowTemplateCategory;
}

const categoryColors: Record<WorkflowTemplateCategory, Color> = {
  Operations: orange,
  Investor: blue,
  "Direct Investments": deepPurple,
  "Fund Investments": teal,
};

const workflowTypeIcons: Record<WorkflowType, SvgIconComponent> = {
  InvoiceProcessing: ReceiptLongIcon,
  InvestmentAcquisition: CasesIcon,
  InvestorCapitalCall: MoneyIcon,
  FundCapitalCallDistribution: MoneyIcon,
  PcapUpload: UploadFileIcon,
  InvestorCapitalCallChecklist: ChecklistIcon,
  InvestorDistributionChecklist: ChecklistIcon,
  InvestorTransferChecklist: ChecklistIcon,
  NavPreparationChecklist: ChecklistIcon,
  InvestorDetailsChangeRequest: AccountTreeIcon,
  InvestorBankAccountChangeRequest: AccountTreeIcon,
  MembersChangeRequest: AccountTreeIcon,
};

const WorkflowTemplateAvatar = ({ workflowType, category }: Props) => {
  const Icon = workflowTypeIcons[workflowType] || AccountTreeIcon;

  return (
    <Avatar
      variant="rounded"
      sx={(t) => ({ ...makeModeAwareAccentSurface(t, categoryColors[category] || grey), width: 32, height: 32 })}
    >
      <Icon />
    </Avatar>
  );
};

export default WorkflowTemplateAvatar;
